import React from 'react';
import Select from 'rmwc/Select';
import FocusableSelect from './FocusableSelect';

export const IntRangeSelect = ({ spec, ...props }) => {
  return (
    <Select
      {...props}
      options={Array(spec.max - spec.min + 1)
        .fill()
        .map((e, i) => i + spec.min)}
      focusOption={spec.focus_option}
      placeholder=""
    />
  );
};
